import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { OrderStatuses } from 'entities/Order/model/consts/orderStatuses';

import { ChangeOrderStatusButton } from './ChangeOrderStatusButton';

interface RejectOrderButtonProps {
    orderId: string;
    disabled: boolean;
}

export const RejectOrderButton = memo(
    ({ orderId, disabled }: RejectOrderButtonProps) => {
        const { t } = useTranslation();

        return (
            <ChangeOrderStatusButton
                newStatus={OrderStatuses.REJECTED}
                orderId={orderId}
                messageOnSuccess={t('Order rejected')}
                disabled={disabled}
            >
                {t('Reject')}
            </ChangeOrderStatusButton>
        );
    },
);
